export enum moduleAlertsNames {
  SET_ALERTS = "SET_ALERTS",
}
